// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j78PM","content":"styles_content__29iXS","tableWrap":"styles_tableWrap__3s4ld"};